import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Bind } from 'lodash-decorators/bind';
import { observer } from 'mobx-react';

import messages from './TeamOfExpertsView.intl';
import { STATIC_TAXONOMY } from 'common/consts/staticTaxonomy';

//styles
import styles from './TeamOfExpertsView.module.scss';

//components
import { Container, Title } from 'common/components/Layout/Layout';
import Filters from 'common/components/Filters/Filters';
import EmployeeList from './components/EmployeesList/EmployeeList';

import ContentStore from 'stores/Content.store';
import InjectMetaTags from 'common/components/InjectMetaTags/InjectMetaTags';

@injectIntl
@observer
export default class TeamOfExpertsViewV extends Component {
  constructor(props) {
    super(props);

    this.filtersList = [
      {
        text: this.props.intl.formatMessage(messages.filterAll),
        value: [
          STATIC_TAXONOMY.POSITION_TYPE.values.TECHNOLOGY,
          STATIC_TAXONOMY.POSITION_TYPE.values.BUSINESS,
          STATIC_TAXONOMY.POSITION_TYPE.values.HR
        ]
      },
      {
        text: this.props.intl.formatMessage(messages.filterTechnology),
        value: STATIC_TAXONOMY.POSITION_TYPE.values.TECHNOLOGY
      },
      {
        text: this.props.intl.formatMessage(messages.filterBusiness),
        value: STATIC_TAXONOMY.POSITION_TYPE.values.BUSINESS
      },
      {
        text: this.props.intl.formatMessage(messages.filterHR),
        value: STATIC_TAXONOMY.POSITION_TYPE.values.HR
      }
    ];

    this.state = {
      selectedFilter: this.filtersList[0],
      selectedPersonIndex: 0
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    const { selectedFilter, selectedPersonIndex } = this.state;
    return (
      <Container>
        {ContentStore.isLoaded && (
          <InjectMetaTags {...ContentStore.content.teamOfExpertsSEO} />
        )}
        <div className={styles.TeamOfExperts}>
          <div className={styles.TeamOfExpertsHeader}>
            <Title title={this.props.intl.formatMessage(messages.heading)} />
            <Filters
              filters={this.filtersList}
              activeFilter={selectedFilter}
              onSelect={this.selectedFilterHandler}
              className={styles.Filters}
            />
          </div>
          <EmployeeList
            scope={selectedFilter.value}
            handler={this.selectedPersonHandler}
            selectedPersonIndex={selectedPersonIndex}
          />
        </div>
      </Container>
    );
  }

  @Bind()
  selectedFilterHandler(e) {
    this.setState({
      selectedPersonIndex: 0,
      selectedFilter: e
    });
  }

  @Bind()
  selectedPersonHandler(e) {
    this.setState({ selectedPersonIndex: e });
  }
}



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/TeamOfExpertsView.js